import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';
import { makeObservable, observable } from 'mobx';

export interface IBookingCutoffsUserDisplayNamesAttributes extends IModelAttributes {
	bookingCutoffId: string;
	userDisplayNameId: string;

	bookingCutoff: Models.BookingCutoffEntity | Models.IBookingCutoffEntityAttributes;
	userDisplayName: Models.UserDisplayNameEntity | Models.IUserDisplayNameEntityAttributes;
}

@entity('BookingCutoffsUserDisplayNames')
export default class BookingCutoffsUserDisplayNames extends Model implements IBookingCutoffsUserDisplayNamesAttributes {
	@observable
	@attribute()
	public bookingCutoffId: string;

	@observable
	@attribute()
	public userDisplayNameId: string;

	@observable
	@attribute({ isReference: true })
	public bookingCutoff: Models.BookingCutoffEntity;

	@observable
	@attribute({ isReference: true })
	public userDisplayName: Models.UserDisplayNameEntity;

	constructor(attributes?: Partial<IBookingCutoffsUserDisplayNamesAttributes>) {
		super(attributes);

		makeObservable(this);

		if (attributes) {
			if (attributes.bookingCutoffId) {
				this.bookingCutoffId = attributes.bookingCutoffId;
			}
			if (attributes.userDisplayNameId) {
				this.userDisplayNameId = attributes.userDisplayNameId;
			}

			if (attributes.bookingCutoff) {
				if (attributes.bookingCutoff instanceof Models.BookingCutoffEntity) {
					this.bookingCutoff = attributes.bookingCutoff;
					this.bookingCutoffId = attributes.bookingCutoff.id;
				} else {
					this.bookingCutoff = new Models.BookingCutoffEntity(attributes.bookingCutoff);
					this.bookingCutoffId = this.bookingCutoff.id;
				}
			} else if (attributes.bookingCutoffId !== undefined) {
				this.bookingCutoffId = attributes.bookingCutoffId;
			}

			if (attributes.userDisplayName) {
				if (attributes.userDisplayName instanceof Models.UserDisplayNameEntity) {
					this.userDisplayName = attributes.userDisplayName;
					this.userDisplayNameId = attributes.userDisplayName.id;
				} else {
					this.userDisplayName = new Models.UserDisplayNameEntity(attributes.userDisplayName);
					this.userDisplayNameId = this.userDisplayName.id;
				}
			} else if (attributes.userDisplayNameId !== undefined) {
				this.userDisplayNameId = attributes.userDisplayNameId;
			}
		}
	}
}
